import { BookOpenIcon } from './BookOpenIcon';

/**
 * author: Google
 * id 7EFAD89C-D84E-41F0-A8A4-F72AC8DB470C
 * name book-open
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-open.svg
 * tags
 */
export const ChromeReaderModeIcon = BookOpenIcon;
export default ChromeReaderModeIcon